import { FC, useEffect, useState } from 'react';
import AceEditor, { IAceEditorProps } from 'react-ace';
import 'ace-builds/src-noconflict/ext-searchbox';
import 'ace-builds/src-noconflict/mode-javascript';
import JSHINT from 'jshint';

type Annotation = {
  row: number;
  column: number;
  text: string;
  type: 'error' | 'warning' | 'info';
};

export const CodeEditor: FC<IAceEditorProps> = ({ onChange, ...props }) => {
  const [annotations, setAnnotations] = useState<Annotation[]>([]);

  const evaluate = (value: string) => {
    const annotations: Annotation[] = [];

    JSHINT.JSHINT(value, { esversion: 11 });

    const results = JSHINT.JSHINT.errors;
    results.forEach((result) => {
      if (result) {
        annotations.push({
          row: result.line - 1,
          column: result.character - 1,
          text: result.reason,
          type: result.code.toLowerCase().startsWith('w') ? 'warning' : 'error'
        });
      }
    });

    setAnnotations(annotations);
  };

  useEffect(() => {
    evaluate(props.value ?? '');
  }, []);

  const handleChange = (value: string) => {
    evaluate(value);

    if (onChange) {
      onChange(value);
    }
  };

  return (
    <AceEditor
      mode="javascript"
      onChange={handleChange}
      editorProps={{ $blockScrolling: true }}
      fontSize={14}
      lineHeight={19}
      showPrintMargin={true}
      showGutter={true}
      highlightActiveLine={true}
      setOptions={{
        enableBasicAutocompletion: false,
        enableLiveAutocompletion: false,
        enableSnippets: false,
        showLineNumbers: true,
        tabSize: 2,
        useWorker: false,
        ...(props.setOptions ?? {})
      }}
      annotations={annotations}
      width="100%"
      focus
      {...props}
    />
  );
};
